import { useState } from "react";
import { Column, Row, Select, SelectOption, Text } from "@amzn/meridian";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/store";
import { setSideMenuSelectedHash } from "src/store/uiSlice";
import {
  REGION_OPTIONS,
  getCurrentRegion,
  buildRegionUrl,
} from "src/utils/regionUtils";
import "./changeRegion.scss";

const RegionPreferencesPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectedRegion, setSelectedRegion] =
    useState<string>(getCurrentRegion());

  const handleSave = () => {
    const currentRegion = getCurrentRegion();
    if (selectedRegion !== currentRegion) {
      const newUrl = buildRegionUrl(selectedRegion);
      window.location.href = newUrl;
    } else {
      dispatch(setSideMenuSelectedHash("#newChat"));
      navigate("/");
    }
  };

  const handleCancel = () => {
    dispatch(setSideMenuSelectedHash("#newChat"));
    navigate("/");
  };

  return (
    <div className="region-preferences">
      <Column spacing="500" width={540}>
        <Column spacing={"200"}>
          {" "}
          <Text type="d100">Change Region</Text>
          <Text type="b300" color="secondary">
            Select your preferred region for SAIGE content and services
          </Text>
        </Column>

        <Column spacing="400">
          <Text type="h200">Region</Text>

          <Select
            value={selectedRegion}
            onChange={setSelectedRegion}
            width="100%"
          >
            {[...REGION_OPTIONS]
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((option) => (
                <SelectOption
                  key={option.value}
                  value={option.value}
                  label={option.label}
                />
              ))}
          </Select>
        </Column>

        <Row alignmentHorizontal="end" spacing="400">
          <button
            disabled={selectedRegion === getCurrentRegion()}
            onClick={handleSave}
            className="change-region-btn"
          >
            Select Region
          </button>
        </Row>
      </Column>
    </div>
  );
};

export default RegionPreferencesPage;
